import { render } from "./InfoGrid.vue?vue&type=template&id=6ae34fdc&ts=true"
import script from "./InfoGrid.vue?vue&type=script&lang=ts"
export * from "./InfoGrid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\callum\\Work\\edenic-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__